"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditLink = exports.RenderLink = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
function checkUrl(url) {
    if (url.startsWith('http://') ||
        url.startsWith('https://') ||
        url.startsWith('mailto:')) {
        return url;
    }
    return "http://".concat(url);
}
var RenderLink = function (props) { return (React.createElement("div", { className: 'element-row link' },
    props.element.description && (React.createElement("div", null,
        React.createElement("b", null,
            props.element.description,
            ":"))),
    React.createElement("div", null,
        React.createElement("a", { href: checkUrl(props.element.url), target: '_blank' }, props.element.displayName || props.element.url)))); };
exports.RenderLink = RenderLink;
var EditLink = function (props) { return (React.createElement("div", { className: 'element link' },
    React.createElement("div", { className: 'description' },
        React.createElement("label", null, (0, translation_1.getLocalization)('dashboardElements/modal/description')),
        React.createElement(sok_ui_1.TextInput, { value: props.element.description, placeholder: (0, translation_1.getLocalization)('dashboardElements/modal/addDescription'), disabled: props.saveStatus === 'FETCHING', onChange: function (_a) {
                var value = _a.target.value;
                return props.updateElement(props.i, 'description', value);
            } }),
        props.errors !== null &&
            props.errors["element-".concat(props.i, "-description")] && (React.createElement("p", { className: 'validation-error' }, props.errors["element-".concat(props.i, "-description")][0]))),
    React.createElement("div", { className: "values link" },
        React.createElement("div", { className: 'link-row-1' },
            React.createElement("div", null,
                React.createElement("label", null, (0, translation_1.getLocalization)('dashboardElements/modal/url')),
                React.createElement(sok_ui_1.TextInput, { value: props.element.url, placeholder: (0, translation_1.getLocalization)('dashboardElements/modal/addUrl'), disabled: props.saveStatus === 'FETCHING', onChange: function (_a) {
                        var value = _a.target.value;
                        return props.updateElement(props.i, 'url', value);
                    } })),
            React.createElement("div", { className: 'remove', onClick: function () {
                    return props.saveStatus !== 'FETCHING' && props.removeElement(props.i);
                } },
                React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' }))),
        props.errors !== null && props.errors["element-".concat(props.i, "-url")] && (React.createElement("div", { className: 'link-row-1' },
            React.createElement("div", null,
                React.createElement("p", { className: 'validation-error' }, props.errors["element-".concat(props.i, "-url")][0])))),
        React.createElement("div", { className: 'link-row-2' },
            React.createElement("span", null,
                React.createElement(sok_ui_1.Input, { disabled: props.saveStatus === 'FETCHING', type: 'checkbox', onChange: function (e) {
                        return props.updateElement(props.i, 'displayName', e.target.checked ? '' : null);
                    } })),
            React.createElement("div", null,
                React.createElement(sok_ui_1.TextInput, { disabled: props.element.displayName === null ||
                        props.saveStatus === 'FETCHING', placeholder: (0, translation_1.getLocalization)('dashboardElements/modal/displayName'), value: props.element.displayName || '', onChange: function (_a) {
                        var value = _a.target.value;
                        return props.updateElement(props.i, 'displayName', value);
                    } }))),
        props.errors !== null &&
            props.errors["element-".concat(props.i, "-displayName")] && (React.createElement("div", { className: 'link-row-2' },
            React.createElement("div", null,
                React.createElement("p", { className: 'validation-error' }, props.errors["element-".concat(props.i, "-displayName")][0]))))))); };
exports.EditLink = EditLink;
